<template>
  <div style="display: none" v-html="JSON.stringify(object)">
  </div>
</template>
<script>
  import {createProp} from "../../common/utils";

  export default {
    props: {
      object: createProp([Object,String,Array])
    }
  }
</script>



// WEBPACK FOOTER //
// src/wenxing/components/jsonDiv.vue